import styled from '@emotion/styled'

import { Input } from '@cash-design-system/react'

export const GiantInput = styled(Input)`
  ${({ theme }) => theme.typography.numeralLarge}
  padding: ${({ theme }) => theme.spacing.m};
  text-align: center;
  width: 100%;
`
